<script lang="ts" setup>
  import { Button } from '../button';
  import { Logo } from '../logo';
  import { LogoText } from '../logo-text';
  import { MobileViewLayout } from '../mobile-view-layout';

  defineProps<{ message: string; userActionName: string }>();
  defineEmits<{ goToStart: [] }>();
</script>

<template>
  <MobileViewLayout justify="center" space="xl">
    <div class="group">
      <Logo />
      <LogoText text="Songstar" />
    </div>
    <div class="group">
      <p class="message">{{ message }}</p>
      <Button :data-faro-user-action-name="userActionName" @click="$emit('goToStart')">Go to start</Button>
    </div>
  </MobileViewLayout>
</template>

<style scoped>
  .group {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;
  }

  .message {
    margin: 0;
  }
</style>
